import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["shared"]

  connect() {
    console.log('connecting to user goals controller')
    var this_controller = this;
  }

  toggleAssignees() {
    const isChecked = this.sharedTarget.checked;
    const assignee_ids_multiselect = document.getElementById('user_goal_assignee_ids')
    const assignee_ids_form_row = assignee_ids_multiselect.closest('.form-row')

    if (isChecked) {
      assignee_ids_multiselect.dispatchEvent(new CustomEvent('update:modelValue', {
        detail: [],
        bubbles: true
      }))
      assignee_ids_form_row.hidden = true
    } else {
      assignee_ids_form_row.hidden = false
    }
  }

  // updateSubmitButton() {
  //   const isChecked = this.sharedTarget.checked;

  //   if (isChecked) {
  //     this.submitButtonTarget.disabled = this.bodyTarget.value.length == 0;
  //   } else {
  //     this.submitButtonTarget.disabled = (this.bodyTarget.value.length == 0 || $(this.assigneesTarget).val().length < 1);
  //   }
  // }
}
